/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const ROUND_RESULT_TITLES = {
    FIRST_BATTLE_VICTORY: (
        <FormattedMessage
            id='post_battle.round_result.titles.first_battle.victory'
            defaultMessage='Победа в бою на границе'
        />
    ),
    FIRST_BATTLE_DEFEAT: (
        <FormattedMessage
            id='post_battle.round_result.titles.first_battle.defeat'
            defaultMessage='Поражение в бою на границе'
        />
    ),
    FIRST_BATTLE_DRAW: (
        <FormattedMessage
            id='post_battle.round_result.titles.first_battle.draw'
            defaultMessage='Ничья в бою на границе'
        />
    ),
    FRONT_LINE_OWN_VICTORY: (
        <FormattedMessage
            id='post_battle.round_result.titles.front_line_battle.own.victory'
            defaultMessage='Победа в защите передового рубежа союзников'
        />
    ),
    FRONT_LINE_OWN_DEFEAT: (
        <FormattedMessage
            id='post_battle.round_result.titles.front_line_battle.own.defeat'
            defaultMessage='Поражение в защите передового рубежа союзников'
        />
    ),
    FRONT_LINE_ENEMY_VICTORY: (
        <FormattedMessage
            id='post_battle.round_result.titles.front_line_battle.enemy.victory'
            defaultMessage='Победа в атаке передового рубежа противника'
        />
    ),
    FRONT_LINE_ENEMY_DEFEAT: (
        <FormattedMessage
            id='post_battle.round_result.titles.front_line_battle.enemy.defeat'
            defaultMessage='Поражение в атаке передового рубежа противника'
        />
    ),
    BACK_LINE_OWN_VICTORY: (
        <FormattedMessage
            id='post_battle.round_result.titles.back_line_battle.own.victory'
            defaultMessage='Победа в защите запасного рубежа союзников'
        />
    ),
    BACK_LINE_OWN_DEFEAT: (
        <FormattedMessage
            id='post_battle.round_result.titles.back_line_battle.own.defeat'
            defaultMessage='Поражение в защите запасного рубежа союзников'
        />
    ),
    BACK_LINE_ENEMY_VICTORY: (
        <FormattedMessage
            id='post_battle.round_result.titles.back_line_battle.enemy.victory'
            defaultMessage='Победа в атаке запасного рубежа противника'
        />
    ),
    BACK_LINE_ENEMY_DEFEAT: (
        <FormattedMessage
            id='post_battle.round_result.titles.back_line_battle.enemy.defeat'
            defaultMessage='Поражение в атаке запасного рубежа противника'
        />
    ),
    CITADEL_OWN_VICTORY: (
        <FormattedMessage
            id='post_battle.round_result.titles.citadel_battle.own.victory'
            defaultMessage='Победа в защите Цитадели союзников'
        />
    ),
    CITADEL_OWN_DEFEAT: (
        <FormattedMessage
            id='post_battle.round_result.titles.citadel_battle.own.defeat'
            defaultMessage='Поражение в защите Цитадели союзников'
        />
    ),
    CITADEL_ENEMY_VICTORY: (
        <FormattedMessage
            id='post_battle.round_result.titles.citadel_battle.enemy.victory'
            defaultMessage='Победа в атаке Цитадели противника'
        />
    ),
    CITADEL_ENEMY_DEFEAT: (
        <FormattedMessage
            id='post_battle.round_result.titles.citadel_battle.enemy.defeat'
            defaultMessage='Поражение в атаке Цитадели противника'
        />
    ),
}



// WEBPACK FOOTER //
// ./containers/PostbattleScreen/components/RoundResultTooltip/constants.jsx